import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import 'slick-carousel';
import 'magnific-popup';
import 'imagesLoaded';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';

// make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, $);

export default {
    links() {
        /** SKIP LINK NAVIGATION */
        $('#skip-to-content').click(function () {
            // strip the leading hash and declare
            // the content we're skipping to
            var skipTo = '#' + this.href.split('#')[1];
            // Setting 'tabindex' to -1 takes an element out of normal
            // tab flow but allows it to be focused via javascript
            $(skipTo)
                .attr('tabindex', -1)
                .on('blur focusout', function () {
                    // when focus leaves this element,
                    // remove the tabindex attribute
                    $(this).removeAttr('tabindex');
                })
                .focus(); // focus on the content container
        });
        /** END SKIP LINK NAVIGATION */

        /** ANIMATED ANCHOR LINKS **/
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            // Doesn't do it on page builder tabs
            if (!$(this).closest('li').hasClass('vc_tta-tab')) {
                if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                    if (
                        location.pathname.replace(/^\//, '') ===
                            this.pathname.replace(/^\//, '') &&
                        location.hostname === this.hostname
                    ) {
                        var target = $(this.hash);
                        var $this = this;
                        var header = $('header.header');
                        var wpAdminBar = $('#wpadminbar');
                        var fixedHeaderOffset =
                            parseInt(header.outerHeight()) -
                            parseInt(
                                header.css('padding-top').replace('px', '')
                            );
                        // If we're logged in and WP ADmin Bar exists, add it to the offset
                        if (wpAdminBar.length) {
                            fixedHeaderOffset += parseInt(
                                wpAdminBar.outerHeight()
                            );
                        }
                        target = target.length
                            ? target
                            : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate(
                                {
                                    scrollTop:
                                        target.offset().top - fixedHeaderOffset,
                                },
                                500,
                                function () {
                                    if (history.pushState) {
                                        history.pushState(
                                            null,
                                            null,
                                            $this.hash
                                        );
                                    } else {
                                        location.hash = $this.hash;
                                    }
                                }
                            );
                            e.preventDefault();
                        }
                    }
                }
            }
        });
        /** END ANIMATED ANCHOR LINKS **/

        /** Break link text to new line when link text is a URL **/
        $(document).ready(function () {
            $('a').each(function () {
                var $this = $(this);
                var innerLink = $this.text();
                if (innerLink.startsWith('http')) {
                    $this.css('word-break', 'break-all');
                }
            });
        });
        /** End Break link text to new line when link text is a URL **/
    },
    itemReveal() {
        // eslint-disable-next-line no-unused-vars
        // var $itemReveals = $('.reveal').waypoint({
        //   handler: function () {
        //     $(this)[0].element.classList.add('revealed');
        //   },
        //   offset: '85%',
        // });

        // Use gsap and ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);
        let reveals = gsap.utils.toArray('.reveal');
        reveals.forEach((reveal) => {
            ScrollTrigger.create({
                trigger: reveal,
                start: 'top 75%', // when the top of the element is 75% from the top of the viewport
                toggleClass: 'revealed',
                // toggleActions: 'play pause resume none',
                once: true, // only trigger the toggle once. we can control repeat behavior using toggleActions
            });
        });

        // Stagger reveals with a gsap.timeline() + ScrollTrigger
        let staggers = gsap.utils.toArray('.reveal--staggered');
        staggers.forEach((stagger) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: stagger,
                    start: 'top 75%',
                },
            });

            let children = stagger.children; // the immediate children elements of the current target

            tl.to(children, {
                duration: 1,
                y: 0,
                opacity: 1,
                stagger: 0.15,
            });
        });
    },
    slider() {
        let featuredNewsSlider = $('.featured-news-slider');

        if (featuredNewsSlider) {
            featuredNewsSlider.each(function () {
                console.log($(this));
                $(this).prepend(
                    '<span class="featured-news-slider__paging"></span>'
                );
                let slider, sliderPaging;
                slider = $(this).find('.visc-posts-list .row');
                // slide = '.featured-news-slider .visc-posts-list .row .col';
                sliderPaging = $(this).find('.featured-news-slider__paging');

                slider.on(
                    'init reInit afterChange',
                    function (event, slick, currentSlide) {
                        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                        let i = (currentSlide ? currentSlide : 0) + 1;
                        sliderPaging.text(i + '/' + slick.slideCount);
                    }
                );

                slider.slick({
                    // slide: slide,
                    autoplay: false,
                    fade: false,
                    speed: 1200,
                    infinite: true,
                    cssEase: 'ease',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow: `<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.75 7.22559H21.3145" stroke="#191919" stroke-width="1.37097" stroke-linecap="round"/>
                        <path d="M16.0891 1.0564L22.0014 7.42994L15.832 14.0806" stroke="#191919" stroke-width="1.37097" stroke-linecap="round"/>
                        </svg>
                        </button>`,
                    prevArrow: `<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.25 7.22559L1.68548 7.22558" stroke="#191919" stroke-width="1.37097" stroke-linecap="round"/>
                        <path d="M6.91091 1.0564L0.998614 7.42994L7.16797 14.0806" stroke="#191919" stroke-width="1.37097" stroke-linecap="round"/>
                        </svg>
                        </button>`,
                });
            });
        }

        let grantsHighlightsSlider = $('.visc-grants-highlights-slider');

        if (grantsHighlightsSlider) {
            grantsHighlightsSlider.each(function () {
                console.log($(this));

                let slider, slidesToShow, centerMode;
                slider = $(this).find('.row');
                // slide = '.featured-news-slider .visc-posts-list .row .col';
                slidesToShow = 4;
                centerMode = false;

                slider.slick({
                    // slide: slide,
                    autoplay: false,
                    fade: false,
                    speed: 1200,
                    infinite: false,
                    cssEase: 'ease-in-out',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow: `<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 11H32" stroke="white" stroke-width="4" stroke-linecap="round"/>
                    <path d="M24.375 2L33 11.2979L24 21" stroke="white" stroke-width="4" stroke-linecap="round"/>
                    </svg>                    
                        </button>`,
                    prevArrow: `<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 11L4 11" stroke="white" stroke-width="4" stroke-linecap="round"/>
                    <path d="M11.625 2L3 11.2979L12 21" stroke="white" stroke-width="4" stroke-linecap="round"/>
                    </svg>
                    
                        </button>`,
                    responsive: [
                        {
                            breakpoint: 560, // min-width
                            settings: {
                                slidesToShow: 2,
                                centerMode: centerMode,
                            },
                        },
                        {
                            breakpoint: 992, // min-width
                            settings: {
                                slidesToShow: slidesToShow,
                            },
                        },
                    ],
                });
            });
        }

        let visceralSliderList = $(
            '.visceral-slider .visc-posts-list, .visceral-slider.related-content .container'
        );
        console.log(visceralSliderList);
        let slidesToShow = 2;
        let $progressBar;
        if (visceralSliderList) {
            let visceralSlider = $('.visceral-slider .row');
            let visceralSliderSlides = $('.visceral-slider .row > *');
            visceralSliderList.append(
                '<div class="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span class="slider__label sr-only"></div>'
            );
            if (visceralSliderSlides.length > slidesToShow) {
                $progressBar = $('.visceral-slider .progress');
                console.log($progressBar);
            }
            console.log(visceralSlider);
            if (visceralSlider) {
                visceralSlider.slick({
                    slide: '.visceral-slider .row > .col',
                    autoplay: false,
                    fade: false,
                    speed: 600,
                    infinite: false,
                    cssEase: 'ease',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow: `<button type="button" class="slick-next btn--no-decoration"><span class="screen-reader-text">Next</span><svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 11H32" stroke="#1C69E0" stroke-width="4" stroke-linecap="round"/>
                    <path d="M24.375 2L33 11.2979L24 21" stroke="#1C69E0" stroke-width="4" stroke-linecap="round"/>
                    </svg>                    
                        </button>`,
                    prevArrow: `<button type="button" class="slick-prev btn--no-decoration"><span class="screen-reader-text">Previous</span><svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 11L4 11" stroke="#C2C2C2" stroke-width="4" stroke-linecap="round"/>
                    <path d="M11.625 2L3 11.2979L12 21" stroke="#C2C2C2" stroke-width="4" stroke-linecap="round"/>
                    </svg></button>`,
                    responsive: [
                        {
                            breakpoint: 768, // min-width
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                        {
                            breakpoint: 992, // min-width
                            settings: {
                                slidesToShow: slidesToShow,
                            },
                        },
                    ],
                });

                // progress bar
                if ($progressBar) {
                    let slides;
                    let viewportSmall = window.innerWidth;
                    if (viewportSmall < 768) {
                        slides = 1;
                    } else {
                        slides = 2;
                    }
                    visceralSlider.on(
                        'beforeChange',
                        function (event, slick, currentSlide, nextSlide) {
                            var calc =
                                (nextSlide / (slick.slideCount - slides)) * 100;
                            let progressBarWidth = calc;
                            if (0 === calc) {
                                progressBarWidth = 10;
                            }
                            $progressBar
                                .css(
                                    'background-size',
                                    progressBarWidth + '% 100%'
                                )
                                .attr('aria-valuenow', calc);
                        }
                    );
                }
            }
        }
    },

    customTabs() {
        let $viscTabs = $('.visc-tabs');

        if ($viscTabs.length) {
            $viscTabs.each(function () {
                let $this = $(this);
                let $singleTabs = $this.find('.visc-tab');

                if ($singleTabs.length) {
                    $singleTabs.each(function (i) {
                        $(this).addClass('visc-tab-' + i);

                        if (0 !== i) {
                            $(this).css('display', 'none');
                        }
                    });
                }
                let $tabTitles = $this.find(
                    '.visc-tab .visc-tab-title .elementor-heading-title'
                );

                $this.prepend(
                    '<div class="elementor-container"><div class="visc-tabs__controls"></div></div>'
                );

                if ($tabTitles.length) {
                    $tabTitles.each(function (i) {
                        let $this = $(this);
                        let $tabTitle = $this.text();
                        $this.html($tabTitle);
                        $('.visc-tabs__controls').append(
                            '<div class="visc-tab-control" data-index="' +
                                i +
                                '"><h2 class="eyebrow">' +
                                $tabTitle +
                                '</h2></div>'
                        );
                        $this.css('display', 'none');
                    });
                }

                $this
                    .find('.visc-tab-control')
                    .first()
                    .addClass('visc-tab-control--active');

                $('.visc-tabs__controls .visc-tab-control').on(
                    'click',
                    function () {
                        let $this = $(this);
                        let $index = $this.data('index');
                        console.log($index);
                        console.log(
                            $this.closest('.visc-tabs').find('.visc-tab')
                        );
                        $this
                            .closest('.visc-tabs')
                            .find('.visc-tab-control')
                            .removeClass('visc-tab-control--active');
                        $this.addClass('visc-tab-control--active');
                        $this
                            .closest('.visc-tabs')
                            .find('.visc-tab')
                            .css('display', 'none');
                        $this
                            .closest('.visc-tabs')
                            .find('.visc-tab-' + $index)
                            .css('display', 'block');

                        // Find the corresponding panel
                        let panel = $('.visc-tab-' + $index);
                        // Get the chart canvas element inside it
                        let canvas = panel.find('.visc-charts-canvas');
                        if (canvas) {
                            // Hide the canvas element
                            canvas.hide();
                            console.log(canvas[0].id);
                            // Get the associated ChartJS object
                            let grantsChart =
                                window['viscChart_' + canvas[0].id];

                            if (grantsChart) {
                                // Canvases inside panels default to width and height of zero, so we need to wait until they're ready
                                var waitForCanvasReady = function (
                                    selector,
                                    callback
                                ) {
                                    if (selector[0].width > 0) {
                                        callback();
                                    } else {
                                        setTimeout(function () {
                                            waitForCanvasReady(
                                                selector,
                                                callback
                                            );
                                        }, 5);
                                    }
                                };
                                // Once the canvas is ready we clear it, fade it in and update it to animate.
                                waitForCanvasReady(canvas, function () {
                                    grantsChart.clear();
                                    canvas.fadeIn('fast', function () {
                                        grantsChart.reset();
                                        grantsChart.update();
                                    });
                                });
                            }
                        }
                    }
                );
            });
        }
    },

    timeline() {
        let timeline = $('.visc-timeline');

        if (timeline) {
            timeline.each(function () {
                console.log($(this));

                let navSlider;
                let timelineSlider;
                navSlider = $(this).find('.visc-timeline__navigation');
                timelineSlider = $(this).find('.visc-timeline__items');

                navSlider.slick({
                    // slide: slide,
                    autoplay: false,
                    fade: false,
                    speed: 1200,
                    infinite: false,
                    cssEase: 'ease-in-out',
                    centerMode: true,
                    variableWidth: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: false,
                    asNavFor: timelineSlider,
                    focusOnSelect: true,
                });

                timelineSlider.slick({
                    // slide: slide,
                    autoplay: false,
                    fade: false,
                    speed: 1200,
                    infinite: false,
                    cssEase: 'ease-in-out',
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    asNavFor: navSlider,
                    focusOnSelect: true,
                    nextArrow: `<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="1">
                    <rect width="51" height="51" rx="25.5" fill="#BEC4F1"/>
                    <path d="M22.7679 14.875L19.125 18.7L24.5893 24.4375L19.125 30.175L22.7679 34L31.875 24.4375L22.7679 14.875Z" fill="#040615"/>
                    </g>
                    </svg>               
                        </button>`,
                    prevArrow: `<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="1">
                    <rect x="51" y="51" width="51" height="51" rx="25.5" transform="rotate(180 51 51)" fill="#BEC4F1"/>
                    <path d="M28.2321 36.125L31.875 32.3L26.4107 26.5625L31.875 20.825L28.2321 17L19.125 26.5625L28.2321 36.125Z" fill="#040615"/>
                    </g>
                    </svg>
                    
                    
                        </button>`,
                    responsive: [
                        // {
                        //     breakpoint: 560, // min-width
                        //     settings: {
                        //         slidesToShow: 2,
                        //         centerPadding: '60px',
                        //     },
                        // },
                        {
                            breakpoint: 992, // min-width
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                });

                navSlider.on(
                    'beforeChange',
                    function (event, slick, currentSlide, nextSlide) {
                        console.log(currentSlide);
                        let navSlides = $(this).find('.slick-slide');

                        navSlides.each(function () {
                            if ($(this).attr('data-slick-index') < nextSlide) {
                                $(this).addClass('slick-past');
                            } else {
                                $(this).removeClass('slick-past');
                            }
                        });
                    }
                );
            });
        }
    },
    magnificPopup() {
        let videoLink = $('.modal-link-video');
        if (videoLink) {
            videoLink.magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        }
    },
    masthead() {
        /** MASTHEAD PRGRESSIVE IMAGES **/
        var masthead = document.querySelector('.masthead'),
            placeholderOverlay = document.querySelector('.masthead__overlay');

        if (masthead && placeholderOverlay) {
            // Load full size image. When loaded, fade our placeholder add it as bg to masthead
            var img = new Image();
            img.src = masthead.dataset.imageSrc;
            img.onload = function () {
                placeholderOverlay.classList.add('fade-out');
                masthead.style.backgroundImage = 'url(' + img.src + ')';
            };
        }
        /** END MASTHEAD PRGRESSIVE IMAGES **/
    },
    header() {
        /** FIXED HEADER ANIMATION **/
        var didScroll = false,
            scrollOffset = 100;

        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }

        function scrollPage() {
            var sy = scrollY();
            if (sy > scrollOffset) {
                $('.site-header--fixed').addClass(
                    'site-header--scroll-triggered'
                );
            } else {
                $('.site-header--fixed').removeClass(
                    'site-header--scroll-triggered'
                );
            }
            didScroll = false;
        }

        window.addEventListener('load', scrollPage);
        window.addEventListener(
            'scroll',
            function () {
                // eslint-disable-line no-unused-vars
                if (!didScroll) {
                    didScroll = true;
                    setTimeout(scrollPage, 100);
                }
            },
            false
        );
        /** END FIXED HEADER ANIMATION **/

        /**  SEARCH OVERLAY **/
        const searchIcon = document.querySelector('.site-header__search-icon');
        const siteSearch = document.querySelector('.site-search');
        const siteSearchClose = document.querySelector('.site-search__close');

        searchIcon.addEventListener('click', (e) => {
            e.preventDefault();
            siteSearch.classList.add('site-search--active');
            setTimeout(() => {
                $('.site-search__form input[type="text"]').focus();
            }, 500);
        });
        siteSearchClose.addEventListener('click', () => {
            siteSearch.classList.remove('site-search--active');
        });
        /**  END SEARCH OVERLAY **/

        // Mobile Icon
        $('.mobile-nav-icon').on('click', function () {
            $(this).toggleClass('mobile-nav-icon--active');
            $('.site-header').toggleClass('site-header--mobile-nav-active');
            $('body').toggleClass('mobile-nav-active');
        });

        // Disable click on mobile
        $('.mobile-menu__item--parent .sub-menu-toggle').on(
            'click',
            function () {
                $(this)
                    .parent('.mobile-menu__item')
                    .toggleClass('mobile-menu__item--opened');
            }
        );

        $('.main-menu > .main-menu__item, .site-header__search-icon').on(
            'mouseenter',
            function () {
                $('.site-header').addClass('site-header--sub-menu-active');
            }
        );

        $('.main-menu > .main-menu__item, .site-header__search-icon').on(
            'mouseleave',
            function () {
                $('.site-header').removeClass('site-header--sub-menu-active');
            }
        );
    },
    mainNavAccessibility() {
        let $mainNavigationTopLevelItemLinks = $(
            '.site-header .main-menu > .main-menu__item--parent > button'
        );

        if ($mainNavigationTopLevelItemLinks.length) {
            $mainNavigationTopLevelItemLinks.each(function () {
                $(this).prev('a').attr('aria-haspopup', 'true');
                $(this).on('click', function () {
                    $(this).closest('li').toggleClass('sub-menu-open');
                    $(this).attr('aria-expanded', 'true');
                });
            });
        }
    },
    mobileNav() {
        let $mobileNavigationTopLevelItemLinks = $(
            '.mobile-menu__item--parent > .mobile-menu__link'
        );

        if ($mobileNavigationTopLevelItemLinks.length) {
            $mobileNavigationTopLevelItemLinks.each(function () {
                $(this).on('click', function (e) {
                    e.preventDefault();
                    $(this)
                        .closest('.mobile-menu__item')
                        .find('ul')
                        .slideToggle('fast');
                });
            });
        }
    },
    ajaxLoadMore() {
        // AJAX Load More
        function visc_load_more() {
            // eslint-disable-next-line no-undef
            if (visceral_vars !== undefined) {
                var data = {
                    action: 'visc_load_more',
                    // eslint-disable-next-line no-undef
                    query: visceral_vars.query,
                    // eslint-disable-next-line no-undef
                    paged: visceral_vars.current_page,
                    // eslint-disable-next-line no-undef
                    security: visceral_vars.security,
                };

                var $button = $('.btn--load-more');

                $.ajax({
                    // eslint-disable-next-line no-undef
                    url: visceral_vars.ajaxurl, // AJAX handler
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                    },
                    complete: function () {
                        this.itemReveal();
                    },
                    success: function (data) {
                        $button.blur();
                        if (data) {
                            $button.find('span').text('Load More');

                            var $postsContainer = $(
                                '.posts-list-container > div'
                            );
                            $postsContainer.append(data);
                            // eslint-disable-next-line no-undef
                            visceral_vars.current_page++;
                            // eslint-disable-next-line no-undef
                            if (
                                // eslint-disable-next-line no-undef
                                visceral_vars.current_page ==
                                // eslint-disable-next-line no-undef
                                visceral_vars.max_page
                            ) {
                                $button.remove(); // if last page, remove the button
                            }
                        } else {
                            $button.remove(); // if last page, remove the button
                        }
                    },
                });
            }
        }

        $('.btn--load-more').on('click', function () {
            visc_load_more();
        });
    },
    socialShare() {
        /**  SOCIAL SHARE OVERLAY **/
        const shareLink = document.querySelector('.visc-social-share-btn');
        const socialShare = document.querySelector('.visc-social-share');
        const socialShareClose = document.querySelector(
            '.visc-social-share__close'
        );

        if (socialShare) {
            shareLink.addEventListener('click', () => {
                // console.log(shareLink);
                socialShare.classList.add('visc-social-share--active');
            });
            socialShareClose.addEventListener('click', () => {
                socialShare.classList.remove('visc-social-share--active');
            });
        }
        /**  END SOCIAL SHARE OVERLAY **/
    },

    buttonDecoration() {
        // Button decorations
        let $buttons = $(
            'button, input[type="button"], input[type="submit"], input[type="reset"], .btn'
        );
        if ($buttons.length) {
            $buttons.each(function () {
                if (
                    !$(this).hasClass('btn--no-decoration') &&
                    !$(this).hasClass('btn--decorated') &&
                    !$(this).hasClass('slick-arrow')
                ) {
                    $(this).addClass('btn--decorated');
                    $(this).wrapInner('<span></span>');
                    if ($(this).hasClass('visc-social-share-btn')) {
                        $(this).append(
                            `<svg class="btn__icon" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6667 15.5553C16.25 15.5553 15.855 15.6329 15.4818 15.7882C15.1085 15.9435 14.7743 16.1506 14.4792 16.4094L6.5625 11.8282C6.59722 11.7074 6.62326 11.5824 6.64062 11.4529C6.65799 11.3235 6.66667 11.1898 6.66667 11.0518C6.66667 10.9137 6.65799 10.78 6.64062 10.6506C6.62326 10.5212 6.59722 10.3961 6.5625 10.2753L14.401 5.74588C14.6962 6.02196 15.0391 6.23765 15.4297 6.39294C15.8203 6.54824 16.2326 6.62588 16.6667 6.62588C17.5868 6.62588 18.3724 6.30236 19.0234 5.65529C19.6745 5.00823 20 4.22746 20 3.31294C20 2.39843 19.6745 1.61765 19.0234 0.970588C18.3724 0.323527 17.5868 0 16.6667 0C15.7465 0 14.9609 0.323527 14.3099 0.970588C13.6589 1.61765 13.3333 2.39843 13.3333 3.31294C13.3333 3.45098 13.342 3.58471 13.3594 3.71412C13.3767 3.84353 13.4028 3.96863 13.4375 4.08941L5.59896 8.64471C5.30382 8.36863 4.96094 8.14863 4.57031 7.98471C4.17969 7.82078 3.76736 7.73882 3.33333 7.73882C2.41319 7.73882 1.62761 8.06235 0.976562 8.70941C0.325518 9.35647 0 10.1372 0 11.0518C0 11.9663 0.325518 12.7471 0.976562 13.3941C1.62761 14.0412 2.41319 14.3647 3.33333 14.3647C3.76736 14.3647 4.17969 14.2871 4.57031 14.1318C4.96094 13.9765 5.30382 13.7608 5.59896 13.4847L13.5156 18.0659C13.4809 18.1867 13.4592 18.3075 13.4505 18.4282C13.4418 18.549 13.4375 18.6698 13.4375 18.7906C13.4375 19.6706 13.75 20.4255 14.375 21.0553C15 21.6851 15.7639 22 16.6667 22C17.5695 22 18.3333 21.6851 18.9583 21.0553C19.5833 20.4255 19.8958 19.6706 19.8958 18.7906C19.8958 17.8933 19.5833 17.1298 18.9583 16.5C18.3333 15.8702 17.5695 15.5553 16.6667 15.5553Z" fill="white"/>
                            </svg>
                            `
                        );
                    } else if ($(this).hasClass('btn--secondary')) {
                        $(this).append(
                            `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="24" height="24" rx="12" fill="#BEC4F1"/>
                            <path d="M11.7143 7L10 8.8L12.5714 11.5L10 14.2L11.7143 16L16 11.5L11.7143 7Z" fill="#0D1760"/>
                            </svg>
                            `
                        );
                    } else {
                        $(this).prepend(
                            `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="24" height="24" rx="12" fill="#BEC4F1"/>
                            <path d="M11.7143 7L10 8.8L12.5714 11.5L10 14.2L11.7143 16L16 11.5L11.7143 7Z" fill="#0D1760"/>
                            </svg>
                            `
                        );
                    }
                }
            });
        }
    },

    linkDecoration() {
        // link decorations
        let $links = $('a.link--arrow-left, a.link--arrow-right');
        if ($links.length) {
            $links.each(function () {
                $(this).wrapInner('<span></span>');
                if ($(this).hasClass('link--arrow-right')) {
                    $(this).append(
                        `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" rx="12" fill="#BEC4F1"/>
                                <path d="M11.7143 7L10 8.8L12.5714 11.5L10 14.2L11.7143 16L16 11.5L11.7143 7Z" fill="#0D1760"/>
                                </svg>
                                `
                    );
                }
                if ($(this).hasClass('link--arrow-left')) {
                    $(this).prepend(
                        `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" rx="12" fill="#BEC4F1"/>
                                <path d="M11.7143 7L10 8.8L12.5714 11.5L10 14.2L11.7143 16L16 11.5L11.7143 7Z" fill="#0D1760"/>
                                </svg>
                                `
                    );
                }
            });
        }
    },

    tabHeading() {
        // Button decorations
        let $tabHeadings = $('.heading--tab');
        let $tabHeadingWrappers = $('.heading-tab-wrapper');
        let elementorContainer = $('.elementor-container');

        if ($tabHeadings.length) {
            $tabHeadings.each(function () {
                $(this).wrap('<span class="heading-tab-wrapper"></span>');
            });
        }

        function stretchTabHeading($tabHeadingWrapper) {
            if (elementorContainer.length) {
                let windowWidth = $(window).width();
                let elementorContainerWidth = elementorContainer.width();
                let margin = (windowWidth - elementorContainerWidth) / 2;
                $tabHeadingWrapper.css({
                    'padding-left': margin + 16 + 'px',
                    transform: 'translate(-' + margin + 'px, calc(-100% + 1px)',
                });
            }
        }
        if ($tabHeadingWrappers.length) {
            $tabHeadingWrappers.each(function () {
                stretchTabHeading($(this));
            });

            $(window).resize(function () {
                $tabHeadingWrappers.each(function () {
                    stretchTabHeading($(this));
                });
            });
        }

        let $footerSignupForm = $('.site-footer .mc4wp-form');

        if ($footerSignupForm.length) {
            $footerSignupForm.each(function () {
                $(this)
                    .find('label[for="signup-email"]')
                    .attr('for', 'footer-signup-email');
                $(this).find('#signup-email').attr('id', 'footer-signup-email');
            });
        }
    },

    init() {
        // JavaScript to be fired on all pages

        /** GLOBAL VARIABLES */
        // var body = document.querySelector('body');
        /** END GLOBAL VARIABLES */

        // Misc. link behaviors
        this.links();

        // Global reveal animations (consider commenting out this and 'gsap' and 'ScrollTrigger' import if not in use)
        this.itemReveal();

        // Slider (consider commenting out this and 'slick-carousel' import if not in use)
        this.slider();

        this.customTabs();

        this.timeline();

        // Modals (consider commenting out this and 'magnific-popup' import if not in use)
        this.magnificPopup();

        // Masthead
        this.masthead();

        // Header
        this.header();

        // Main Nav Accessibility
        this.mainNavAccessibility();

        this.mobileNav();

        // Load more
        this.ajaxLoadMore();

        // Social share
        this.socialShare();

        this.buttonDecoration();
        this.linkDecoration();

        this.tabHeading();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js